import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoClose, IoArrowBack, IoArrowForward } from "react-icons/io5";
import billimg1 from "./Images/billimg1.png";
import Purchasebillimg2 from "./Images/Purchasebillimg2.png";
import Purchasebillimg3 from "./Images/Purchasebillimg3.png";
import Purchasebillimg4 from "./Images/Purchasebillimg4.png";
import Purchasebillimg5 from "./Images/Purchasebillimg5.png";
import Purchasebillimg6 from "./Images/Purchasebillimg6.png";

const PurchasebillTour = ({ topic, onClose }) => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);

  const getPurchaseBillSteps = () => [
    {
      image: billimg1,
      title: "Open Purchase Bills",
      description: "From Inventory Management, click Purchase Bills.",
      popupPosition: { top: "20%", left: "18%" },
    },
    {
      image: billimg1,
      title: "Click Add Purchase Bill",
      description: "Click Add Purchase Bill to create a new purchase bill.",
      popupPosition: { top: "26%", right: "5%" },
    },
    {
      image: Purchasebillimg2,
      title: "Select Supplier",
      description:
        "Select a supplier from the dropdown. Added suppliers will be available here.",
      popupPosition: { top: "42%", left: "20%" },
    },
    {
      image: Purchasebillimg3,
      title: "Enter Purchase Bill Details",
      description: "Fill in the other required purchase bill details.",
      popupPosition: { bottom: "15%", left: "20%" },
    },
    {
      image: Purchasebillimg4,
      title: "Search or Scan Product",
      description:
        "Scan the barcode or enter the product name and press Enter to open the product drawer.",
      popupPosition: { bottom: "0%", left: "20%" },
    },
    {
      image: Purchasebillimg5,
      title: "Select Products",
      description:
        "Select the products you want to add and click Add Selected.",
      popupPosition: { top: "10%", left: "5%" },
    },
    {
      image: Purchasebillimg6,
      title: "Enter details and Save Purchase Bill",
      description:
        "Selected products will appear in the table. Enter the required details and click Save to save or paid and save to pay and save .",
      popupPosition: { bottom: "35%", right: "5%" },
    },
  ];

  const steps = getPurchaseBillSteps();
  const totalSteps = steps.length;
  const current = steps[currentStep];

  const handleNext = () => {
    if (currentStep < totalSteps - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      handleSkip();
    }
  };

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSkip = () => {
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[100] bg-black flex items-center justify-center">
      {/* Full-screen background image */}
      <div className="absolute inset-0">
        <img
          src={current.image}
          alt={`Step ${currentStep + 1}`}
          className="w-full h-full object-contain bg-black"
          onError={(e) => {
            e.target.src =
              "https://via.placeholder.com/1920x1080?text=Tour+Image";
          }}
        />
      </div>

      {/* Global skip button (top right) - optional but handy */}
      <button
        onClick={handleSkip}
        className="absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 rounded-full p-2 transition-colors z-30 backdrop-blur-sm"
        aria-label="Skip tour"
      >
        <IoClose size={24} />
      </button>

      {/* Step indicator dots (bottom center) */}
      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex gap-2 z-30">
        {steps.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrentStep(idx)}
            className={`w-2 h-2 rounded-full transition-all ${
              idx === currentStep
                ? "bg-white w-4"
                : "bg-white/50 hover:bg-white/80"
            }`}
          />
        ))}
      </div>

      {/* Positioned popup for the current step */}
      <div className="absolute z-30" style={current.popupPosition}>
        <div className="bg-white rounded-xl shadow-2xl w-72 md:w-80 p-5 animate-fadeIn">
          {/* Step number */}
          <div className="flex justify-between items-center mb-3">
            <span className="text-xs font-semibold text-blue-600 bg-blue-50 px-2 py-1 rounded-full">
              Step {currentStep + 1} of {totalSteps}
            </span>
            <button
              onClick={handleSkip}
              className="text-xs text-gray-400 hover:text-gray-600"
            >
              Skip
            </button>
          </div>

          {/* Title & description */}
          <h3 className="text-lg font-bold text-gray-800 mb-2">
            {current.title}
          </h3>
          <p className="text-sm text-gray-600 leading-relaxed">
            {current.description}
          </p>

          {/* Navigation buttons inside the popup */}
          <div className="flex justify-between items-center mt-5 pt-3 border-t border-gray-100">
            <button
              onClick={handleBack}
              disabled={currentStep === 0}
              className={`flex items-center gap-1 px-3 py-1.5 rounded-md text-sm font-medium transition ${
                currentStep === 0
                  ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
            >
              <IoArrowBack size={14} /> Back
            </button>
            <button
              onClick={handleNext}
              className="flex items-center gap-1 px-4 py-1.5 bg-blue-600 text-white rounded-md text-sm font-medium hover:bg-blue-700 transition shadow-sm"
            >
              {currentStep === totalSteps - 1 ? "Finish" : "Next"}{" "}
              {currentStep !== totalSteps - 1 && <IoArrowForward size={14} />}
            </button>
          </div>
        </div>
      </div>

      {/* Optional: subtle animation */}
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.2s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default PurchasebillTour;
